export default __webpack_public_path__ + "static/media/bigWhiteCloseIcon.aba31fd7.svg";